import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import IxBottomNav from '../../basic/ix-bottom-nav';
import NxtTopBar from '../../basic/nxt-top-bar';
import IxButton from '../../basic/ix-button';
import NxtTopBarItems from '../../composite/nxt-top-bar-items';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import cartImage from '../../../assets/imgs/common/regiless-takout-empty-cart-img-2x.png';

import { redirectToSearch, redirectToMenu, dateAndTimeGenerator } from '../../../services/utility';
import { fetchOrderedMenus } from '../../business/menu/menuSlice';

const useStyles = makeStyles(theme => ({
  bottomNav: {
    bottom: '0',
    position: 'fixed',
    width: '100%',
    marginLeft: '0em',

    zIndex: theme.zIndex.bottomNav
  },
  accountInfo: {
    textAlign: 'center',
    marginTop: '5rem'
  },
  userName: {
    fontSize: '1.8rem'
  },
  userEmail: {
    fontSize: '1.1rem',
    fontWeight: 400
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgb(0 0 0 / 10%)',
    borderTop: '1px solid rgb(0 0 0 / 10%)'
  },
  orderNo: {
    fontSize: '1.1rem',
    fontWeight: 400
  },
  pending: {
    color: '#FF7733 ',
    fontSize: '.9rem',
    fontWeight: 400
  },
  ready: {
    color: '#52D063',
    fontSize: '.9rem',
    fontWeight: 400
  },
  completed: {
    color: 'rgb(166 172 175)',
    fontSize: '.9rem',
    fontWeight: 400
  },
  orderTime: {
    color: 'rgb(166 172 175)'
  },
  orderPrice: {
    fontWeight: 900,
    color: '#000000'
  },
  buttonContainer: {
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '1rem',
    textAlign: 'center'
  },
  buttonGd: {
    marginBottom: '0.5em',
    '& button': {
      width: '100%'
    }
  },
  btnRegistration: {
    height: '3.2em',
    color: 'black'
  },
  homeImage: {
    display: 'block',
    width: '50%',
    [theme.breakpoints.up("md")]: {
      width: '23%'
    },
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: '1rem'
  },
  listItemSecondColumn: {
    textAlign: 'right'
  }
}));

function OrderHome(props) {
  const { t } = useTranslation(['common']);
  const classes = useStyles();

  const dispatch = useDispatch();
  const { restaurantTable, session } = useSelector(state => state.appState);
  const loggedInUser = useSelector(state => state.appState.registeredUser.data);
  const orderedMenus = useSelector(state => state.menuState.orderedMenus.data);
  const { history } = props;

  const { companyId, id, name, companyName } = session.data;
  const company_id = companyId;
  const branchId = id;
  const restaurantName = name;

  let todaysOrder = orderedMenus?.filter(e => {
    let dateAndTime = new Date(e.orderStartTime);
    let allOrderTime = moment(dateAndTime).format('D MMM, YYYY');
    let today = moment().format('D MMM, YYYY');
    return today === allOrderTime;
  });

  const orderStatus = status => {
    if (status?.pickupStatus === 'COMPLETED') {
      return t('Completed');
    } else if (status?.pickupStatus === 'PENDING') {
      return t('Pending');
    } else {
      return t('Ready for pick up');
    }
  };

  useEffect(() => {
    dispatch(fetchOrderedMenus());
  }, []);


  return (
    <div>
      <Box className={classes.bottomNav} component='span'>
        <IxBottomNav props={props}></IxBottomNav>
      </Box>

      <div>
        <NxtTopBar isArrow = {false}>
          <NxtTopBarItems
            title={companyName}
            titleAlignment='left'
            handleSearchButton={() => redirectToSearch(history)}
          ></NxtTopBarItems>
        </NxtTopBar>
        <List>
          <ListItem className={classes.accountInfo}>
            <ListItemText
              classes={{
                primary: classes.userName,
                secondary: classes.userEmail
              }}
              primary={`${(loggedInUser?.firstName || loggedInUser?.lastName) ? t('Hello,') : ''} ${ loggedInUser?.firstName ?? ''} ${loggedInUser?.lastName ?? ''}`}
              secondary={todaysOrder ? `${t('You have')} ${todaysOrder.length} ${t('orders in-progress')}` : `${t('noOrder')}`}
            />
          </ListItem>

          { (!todaysOrder || todaysOrder?.length === 0)  && <img className={classes.homeImage} src={cartImage} alt="nxt-guide-visual" />}
          
          {todaysOrder && todaysOrder?.length>0 &&(
            <div style={{overflowY: 'scroll', height: '40vh'}}>
          {todaysOrder?.map((e, i) => (
          <div className={classes.listItem} key={i} >
            <ListItem>
              <ListItemText
                classes={{
                  primary: classes.orderNo,
                  secondary:  orderStatus(e) === 'Pending' ? classes.pending : orderStatus(e) === 'Completed' ? classes.completed : classes.ready
                }}
                primary={`${t('Order')} #${e.displayOrderNo}`}
                secondary={orderStatus(e)}
              />
            </ListItem>

            <ListItem>
              <ListItemText
                classes={{
                  primary: classes.orderTime,
                  secondary: classes.orderPrice
                }}
                className={classes.listItemSecondColumn}
                primary={dateAndTimeGenerator(e)}
                secondary={`￥${e.totalDecimal}`}
              />
            </ListItem>
          </div>
        ))}
        </div>)}
        
        </List>
        <Grid className={classes.buttonContainer}>
          <Grid
            className={classes.buttonGd}
            container
            justify='center'
            item
            direction='row'
          >
            <IxButton
              onClick={() => redirectToMenu(history)}
              variant='contained'
              color='primary'
            >
              {t('chooseMenu')}
            </IxButton>
          </Grid>
          <Grid
            className={classes.buttonGd}
            container
            justify='center'
            item
            direction='row'
          >
            <IxButton
              className={classes.btnRegistration}
              variant='outlined'
              color='primary'
              // disabled={
              //   editOrderedItems && editOrderedItems.length ? false : true
              // }
              onClick={() => history.push('/recommended')}
            >
              {t('viewRecom')}
            </IxButton>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default OrderHome;
